import React, { useEffect } from 'react'

const policies = {
  privacy: {
    title: 'Privacy Policy',
    content: [
      {
        heading: 'Overview',
        text: 'TalentHouse NZ ("we", "us", "our") is committed to protecting your personal information in accordance with the New Zealand Privacy Act 2020.'
      },
      {
        heading: 'Information We Collect',
        text: 'We collect personal information you voluntarily provide when contacting us or applying for roles, including your name, email address, phone number, and CV/resume details.'
      },
      {
        heading: 'How We Use Your Information',
        text: 'Your information is used to match you with suitable job opportunities, communicate with you about roles, and improve our recruitment services. We do not sell your personal information to third parties.'
      },
      {
        heading: 'Storage & Security',
        text: 'Your data is stored securely and accessible only to authorised TalentHouse staff. We take reasonable steps to protect your information from unauthorised access, loss, or disclosure.'
      },
      {
        heading: 'Your Rights',
        text: 'Under the Privacy Act 2020, you have the right to access and correct personal information we hold about you. To make a request, contact us at admin@talenthouse.nz.'
      },
      {
        heading: 'Contact',
        text: 'For any privacy-related queries, please email admin@talenthouse.nz.'
      }
    ]
  },
  terms: {
    title: 'Terms of Service',
    content: [
      {
        heading: 'Acceptance of Terms',
        text: 'By accessing or using the TalentHouse NZ website, you agree to be bound by these Terms of Service. If you do not agree, please do not use this site.'
      },
      {
        heading: 'Services',
        text: 'TalentHouse NZ provides recruitment and staffing services. Job listings are published in good faith and are subject to change or removal without notice.'
      },
      {
        heading: 'Accuracy of Information',
        text: 'We strive to keep all content accurate and up to date. However, we make no warranties about the completeness or accuracy of job listings or other content on this site.'
      },
      {
        heading: 'Intellectual Property',
        text: 'All content on this website, including text, images, and design, is the property of TalentHouse NZ and may not be reproduced without written permission.'
      },
      {
        heading: 'Limitation of Liability',
        text: 'TalentHouse NZ is not liable for any direct or indirect loss arising from your use of this website or reliance on any information provided herein.'
      },
      {
        heading: 'Governing Law',
        text: 'These terms are governed by the laws of New Zealand. Any disputes will be subject to the exclusive jurisdiction of the New Zealand courts.'
      }
    ]
  },
  cookies: {
    title: 'Cookie Policy',
    content: [
      {
        heading: 'What Are Cookies',
        text: 'Cookies are small text files stored on your device when you visit a website. They help us provide a better user experience by remembering your preferences.'
      },
      {
        heading: 'Cookies We Use',
        text: 'We use essential session cookies necessary for the website to function, and may use analytics cookies to understand how visitors interact with our site.'
      },
      {
        heading: 'Third-Party Cookies',
        text: 'Our contact form uses Web3Forms with a honeypot spam-protection field. No third-party cookies are set by this mechanism.'
      },
      {
        heading: 'Managing Cookies',
        text: 'You can control or delete cookies through your browser settings. Note that disabling cookies may affect some features of this website.'
      },
      {
        heading: 'Contact',
        text: 'If you have questions about our cookie usage, contact us at admin@talenthouse.nz.'
      }
    ]
  }
}

const LegalModal = ({ type, onClose }) => {
  const policy = policies[type]

  useEffect(() => {
    document.body.classList.add('modal-open')
    const handleKeyDown = (e) => { if (e.key === 'Escape') onClose() }
    window.addEventListener('keydown', handleKeyDown)
    return () => {
      document.body.classList.remove('modal-open')
      window.removeEventListener('keydown', handleKeyDown)
    }
  }, [onClose])

  if (!policy) return null

  return (
    <div className="legal-modal-overlay" onClick={onClose}>
      <div className="legal-modal" onClick={e => e.stopPropagation()}>
        <div className="legal-modal-header">
          <h2>{policy.title}</h2>
          <button className="btn-close" aria-label="Close" onClick={onClose}>
            <i className="fas fa-times"></i>
          </button>
        </div>
        <div className="legal-modal-body">
          <p className="legal-effective">Effective date: 1 January 2026</p>
          {policy.content.map((section, i) => (
            <div key={i} className="legal-section">
              <h3>{section.heading}</h3>
              <p>{section.text}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default LegalModal
